/**
 * Created by zoechodosh on 1/18/17.
 */
import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import {
  updateEntityRequest,
  receiveEntityResponse,
  receiveUpdatedEntityResponse,
  getEntitiesRequest,
  getEntitiesResponse,
  editEntityRequest,
  TRAVEL_TYPES,
} from '../EntityActions';

const ENTITY_LIST_NAME = 'travels';

export function getTravel() {
  return dispatch => {
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v1/cms/page/travel', {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then(json => dispatch(getEntitiesResponse(json, ENTITY_LIST_NAME)));
  };
}

export const editTravel = travel => dispatch => {
  dispatch(editEntityRequest(travel));
};

export function addTravel(createTravelRequest) {
  const { type } = createTravelRequest;
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/travel/create', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(createTravelRequest),
    })
      .then(response => response.json())
      .then(json => dispatch(receiveEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: `${TRAVEL_TYPES[type]} Added` })));
  };
}

export function updateTravel(updateTravelRequest) {
  const { type } = updateTravelRequest;
  return dispatch => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/travel/update', {
      credentials: 'same-origin',
      headers: {
        'Content-type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(updateTravelRequest),
    })
      .then(response => response.json())
      .then(json => dispatch(receiveUpdatedEntityResponse(json)))
      .then(() => dispatch(toastsActions.positive({ headline: `${TRAVEL_TYPES[type]} Updated` })));
  };
}



// WEBPACK FOOTER //
// ./src/actions/website/entities/TravelActions.js